import React from "react";
import styles from "./GetStarted.module.css";

const GetStartedSupport = ({ width = 100, height = 100 }) => {
    return (
        <svg viewBox="0 0 72 72" width={width} height={height}>
            <g>
                <path
                    className={styles.cls1}
                    d="M35.64,71.79c-19.48,0-35.33-15.85-35.33-35.33S16.15,1.13,35.64,1.13s35.33,15.85,35.33,35.33
		S55.12,71.79,35.64,71.79z M35.64,4.73C18.14,4.73,3.9,18.96,3.9,36.46s14.23,31.73,31.73,31.73s31.73-14.23,31.73-31.73
		S53.13,4.73,35.64,4.73z"
                />
                <g>
                    <g>
                        <g>
                            <g>
                                <path
                                    className={styles.cls1}
                                    d="M22.88,44.6c-2.24,0-4.06-1.82-4.06-4.06v-3.16c0-2.24,1.82-4.06,4.06-4.06c2.24,0,4.06,1.82,4.06,4.06
						v3.16C26.95,42.78,25.12,44.6,22.88,44.6z M22.88,34.38c-1.65,0-3,1.35-3,3v3.16c0,1.65,1.35,3,3,3s3-1.35,3-3v-3.16
						C25.88,35.72,24.54,34.38,22.88,34.38z"
                                />
                                <path
                                    className={styles.cls1}
                                    d="M22.88,45.2c-2.57,0-4.66-2.09-4.66-4.66v-3.16c0-2.57,2.09-4.66,4.66-4.66s4.66,2.09,4.66,4.66v3.16
						C27.55,43.11,25.45,45.2,22.88,45.2z M22.88,34.98c-1.32,0-2.4,1.08-2.4,2.4v3.16c0,1.32,1.08,2.4,2.4,2.4s2.4-1.08,2.4-2.4
						v-3.16C25.28,36.06,24.21,34.98,22.88,34.98z"
                                />
                            </g>
                        </g>
                        <g>
                            <g>
                                <path
                                    className={styles.cls1}
                                    d="M27.24,54.55h-8.89c-1.62,0-2.93-1.31-2.93-2.93v-3.26c0-0.67,0.41-1.34,1.22-1.98
						c0.65-0.51,1.42-0.89,2.29-1.14l2.76-0.77c0.28-0.08,0.58,0.09,0.66,0.37c0.08,0.28-0.09,0.58-0.37,0.66l-2.76,0.77
						c-0.74,0.21-1.39,0.53-1.93,0.95c-0.53,0.41-0.82,0.82-0.82,1.14v3.26c0,1.03,0.84,1.87,1.87,1.87h8.89
						c1.03,0,1.87-0.84,1.87-1.87v-3.26c0-0.32-0.29-0.73-0.82-1.14c-0.54-0.42-1.19-0.74-1.92-0.95l-2.68-0.75
						c-0.28-0.08-0.45-0.37-0.37-0.66c0.08-0.28,0.37-0.45,0.66-0.37l2.68,0.75c0.87,0.25,1.64,0.63,2.29,1.14
						c0.81,0.64,1.22,1.3,1.22,1.98v3.26C30.17,53.24,28.85,54.55,27.24,54.55z"
                                />
                                <path
                                    className={styles.cls1}
                                    d="M27.24,55.15h-8.89c-1.95,0-3.53-1.58-3.53-3.53v-3.26c0-0.87,0.49-1.69,1.45-2.45
						c0.71-0.56,1.55-0.98,2.5-1.25l2.76-0.77c0.29-0.08,0.59-0.05,0.86,0.1c0.2,0.11,0.35,0.27,0.45,0.47
						c0.25-0.45,0.78-0.69,1.3-0.55l2.68,0.75c0.95,0.27,1.79,0.69,2.5,1.24c0.96,0.76,1.45,1.58,1.45,2.45v3.26
						C30.77,53.57,29.18,55.15,27.24,55.15z M22.82,45.52c-0.14,0.26-0.38,0.46-0.69,0.55l-2.76,0.77
						c-0.66,0.19-1.24,0.47-1.71,0.84c-0.46,0.36-0.58,0.61-0.59,0.67v3.26c0,0.7,0.57,1.27,1.27,1.27h8.89
						c0.7,0,1.27-0.57,1.27-1.27v-3.26c-0.01-0.06-0.13-0.31-0.59-0.67c-0.48-0.38-1.06-0.66-1.72-0.85l-2.68-0.75
						C23.21,46,22.96,45.79,22.82,45.52z"
                                />
                            </g>
                        </g>
                        <g>
                            <g>
                                <path
                                    className={styles.cls1}
                                    d="M21.83,45.51c-0.29,0-0.53-0.24-0.53-0.53v-0.91c0-0.29,0.24-0.53,0.53-0.53c0.29,0,0.53,0.24,0.53,0.53
						v0.91C22.36,45.27,22.12,45.51,21.83,45.51z"
                                />
                                <path
                                    className={styles.cls1}
                                    d="M21.83,46.11c-0.62,0-1.13-0.51-1.13-1.13v-0.91c0-0.62,0.51-1.13,1.13-1.13c0.62,0,1.13,0.51,1.13,1.13
						v0.91C22.96,45.6,22.45,46.11,21.83,46.11z"
                                />
                            </g>
                        </g>
                        <g>
                            <g>
                                <path
                                    className={styles.cls1}
                                    d="M23.83,45.53c-0.29,0-0.53-0.24-0.53-0.53v-0.93c0-0.29,0.24-0.53,0.53-0.53c0.29,0,0.53,0.24,0.53,0.53
						V45C24.36,45.29,24.12,45.53,23.83,45.53z"
                                />
                                <path
                                    className={styles.cls1}
                                    d="M23.83,46.13c-0.62,0-1.13-0.51-1.13-1.13v-0.93c0-0.62,0.51-1.13,1.13-1.13c0.62,0,1.13,0.51,1.13,1.13
						V45C24.96,45.62,24.45,46.13,23.83,46.13z"
                                />
                            </g>
                        </g>
                        <g>
                            <g>
                                <path
                                    className={styles.cls1}
                                    d="M22.79,49.19c-1.44,0-2.6-1.51-2.6-3.37c0-0.21,0.01-0.42,0.04-0.62c0.04-0.29,0.31-0.49,0.6-0.45
						c0.29,0.04,0.49,0.31,0.45,0.6c-0.02,0.15-0.03,0.31-0.03,0.47c0,1.25,0.71,2.31,1.54,2.31c0.84,0,1.54-1.06,1.54-2.31
						c0-0.16-0.01-0.32-0.03-0.47c-0.04-0.29,0.16-0.56,0.45-0.6c0.29-0.04,0.56,0.16,0.6,0.45c0.03,0.2,0.04,0.41,0.04,0.62
						C25.39,47.68,24.23,49.19,22.79,49.19z"
                                />
                                <path
                                    className={styles.cls1}
                                    d="M22.79,49.79c-1.77,0-3.21-1.78-3.21-3.97c0-0.24,0.02-0.48,0.05-0.71c0.04-0.3,0.2-0.56,0.44-0.75
						c0.24-0.18,0.54-0.26,0.84-0.21c0.61,0.09,1.04,0.66,0.96,1.28c-0.02,0.13-0.03,0.25-0.03,0.38c0,0.96,0.51,1.71,0.94,1.71
						s0.94-0.75,0.94-1.71c0-0.13-0.01-0.26-0.03-0.39c-0.09-0.61,0.34-1.19,0.96-1.28c0.62-0.08,1.19,0.34,1.28,0.96
						c0.03,0.23,0.05,0.47,0.05,0.71C25.99,48.01,24.56,49.79,22.79,49.79z"
                                />
                            </g>
                        </g>
                        <g>
                            <g>
                                <path
                                    className={styles.cls1}
                                    d="M24.18,37.95c-0.39,0-0.76-0.08-1.1-0.24c-0.43-0.2-0.7-0.48-0.91-0.71c-0.22-0.23-0.34-0.35-0.53-0.39
						c-0.46-0.11-1.13,0.29-1.89,1.11c-0.2,0.22-0.54,0.23-0.75,0.03c-0.22-0.2-0.23-0.54-0.03-0.75c1.07-1.16,2.03-1.63,2.91-1.42
						c0.52,0.12,0.81,0.42,1.07,0.7c0.18,0.19,0.34,0.36,0.59,0.47c0.43,0.2,1.11,0.32,2.56-0.51c0.26-0.15,0.58-0.06,0.72,0.2
						c0.15,0.25,0.06,0.58-0.2,0.73C25.68,37.69,24.89,37.95,24.18,37.95z"
                                />
                                <path
                                    className={styles.cls1}
                                    d="M24.18,38.55c-0.47,0-0.93-0.1-1.36-0.3c-0.54-0.25-0.86-0.59-1.1-0.84c-0.07-0.07-0.19-0.2-0.23-0.22
						c-0.09-0.04-0.55,0.1-1.32,0.93c-0.42,0.46-1.14,0.49-1.6,0.06c-0.22-0.21-0.35-0.49-0.36-0.79c-0.01-0.3,0.09-0.59,0.3-0.81
						c1.23-1.33,2.37-1.86,3.48-1.6c0.69,0.16,1.08,0.57,1.36,0.86c0.17,0.18,0.27,0.28,0.41,0.35c0.17,0.08,0.64,0.3,2.01-0.49
						c0.54-0.31,1.23-0.12,1.54,0.42c0.15,0.26,0.19,0.57,0.11,0.86c-0.08,0.29-0.27,0.53-0.53,0.68
						C25.88,38.27,24.99,38.55,24.18,38.55z M26.08,36.24l0.23,0.4l0,0L26.08,36.24z"
                                />
                            </g>
                        </g>
                    </g>
                    <g>
                        <g>
                            <g>
                                <path
                                    className={styles.cls1}
                                    d="M48,44.6c-2.24,0-4.06-1.82-4.06-4.06v-3.16c0-2.24,1.82-4.06,4.06-4.06c2.24,0,4.06,1.82,4.06,4.06v3.16
						C52.06,42.78,50.24,44.6,48,44.6z M48,34.38c-1.65,0-3,1.35-3,3v3.16c0,1.65,1.35,3,3,3c1.65,0,3-1.35,3-3v-3.16
						C51,35.72,49.65,34.38,48,34.38z"
                                />
                                <path
                                    className={styles.cls1}
                                    d="M48,45.2c-2.57,0-4.66-2.09-4.66-4.66v-3.16c0-2.57,2.09-4.66,4.66-4.66c2.57,0,4.66,2.09,4.66,4.66v3.16
						C52.66,43.11,50.57,45.2,48,45.2z M48,34.98c-1.32,0-2.4,1.08-2.4,2.4v3.16c0,1.32,1.08,2.4,2.4,2.4s2.4-1.08,2.4-2.4v-3.16
						C50.4,36.06,49.32,34.98,48,34.98z"
                                />
                            </g>
                        </g>
                        <g>
                            <g>
                                <path
                                    className={styles.cls1}
                                    d="M52.35,54.55h-8.89c-1.62,0-2.93-1.31-2.93-2.93v-3.26c0-0.67,0.41-1.34,1.22-1.98
						c0.65-0.51,1.42-0.89,2.29-1.14l2.76-0.77c0.28-0.08,0.58,0.09,0.66,0.37c0.08,0.28-0.09,0.58-0.37,0.66l-2.76,0.77
						c-0.74,0.21-1.38,0.53-1.92,0.95c-0.53,0.41-0.82,0.82-0.82,1.14v3.26c0,1.03,0.84,1.87,1.87,1.87h8.89
						c1.03,0,1.87-0.84,1.87-1.87v-3.26c0-0.32-0.29-0.73-0.82-1.14c-0.54-0.42-1.19-0.74-1.92-0.95l-2.68-0.75
						c-0.28-0.08-0.45-0.37-0.37-0.66c0.08-0.28,0.37-0.45,0.66-0.37l2.68,0.75c0.87,0.24,1.64,0.63,2.29,1.14
						c0.81,0.64,1.22,1.3,1.22,1.98v3.26C55.28,53.24,53.97,54.55,52.35,54.55z"
                                />
                                <path
                                    className={styles.cls1}
                                    d="M52.35,55.15h-8.89c-1.95,0-3.53-1.58-3.53-3.53v-3.26c0-0.87,0.49-1.69,1.45-2.45
						c0.71-0.56,1.55-0.98,2.5-1.25l2.76-0.77c0.53-0.15,1.07,0.1,1.31,0.57c0.25-0.45,0.78-0.69,1.3-0.55l2.68,0.75
						c0.95,0.27,1.79,0.69,2.5,1.24c0.96,0.76,1.45,1.58,1.45,2.45v3.26C55.88,53.57,54.3,55.15,52.35,55.15z M47.94,45.52
						c-0.14,0.26-0.38,0.46-0.69,0.55l-2.76,0.77c-0.66,0.19-1.24,0.47-1.71,0.84c-0.46,0.36-0.58,0.61-0.59,0.67v3.26
						c0,0.7,0.57,1.27,1.27,1.27h8.89c0.7,0,1.27-0.57,1.27-1.27v-3.26c-0.01-0.06-0.13-0.31-0.59-0.67
						c-0.48-0.38-1.06-0.66-1.72-0.85l-2.68-0.75c-0.29-0.08-0.53-0.27-0.68-0.53C47.95,45.54,47.95,45.53,47.94,45.52z"
                                />
                            </g>
                        </g>
                        <g>
                            <g>
                                <path
                                    className={styles.cls1}
                                    d="M46.95,45.51c-0.29,0-0.53-0.24-0.53-0.53v-0.91c0-0.29,0.24-0.53,0.53-0.53c0.29,0,0.53,0.24,0.53,0.53
						v0.91C47.48,45.27,47.24,45.51,46.95,45.51z"
                                />
                                <path
                                    className={styles.cls1}
                                    d="M46.95,46.11c-0.62,0-1.13-0.51-1.13-1.13v-0.91c0-0.62,0.51-1.13,1.13-1.13c0.62,0,1.13,0.51,1.13,1.13
						v0.91C48.08,45.6,47.57,46.11,46.95,46.11z"
                                />
                            </g>
                        </g>
                        <g>
                            <g>
                                <path
                                    className={styles.cls1}
                                    d="M48.94,45.53c-0.29,0-0.53-0.24-0.53-0.53v-0.93c0-0.29,0.24-0.53,0.53-0.53c0.29,0,0.53,0.24,0.53,0.53
						V45C49.48,45.29,49.24,45.53,48.94,45.53z"
                                />
                                <path
                                    className={styles.cls1}
                                    d="M48.94,46.13c-0.62,0-1.13-0.51-1.13-1.13v-0.93c0-0.62,0.51-1.13,1.13-1.13c0.62,0,1.13,0.51,1.13,1.13
						V45C50.08,45.62,49.57,46.13,48.94,46.13z"
                                />
                            </g>
                        </g>
                        <g>
                            <g>
                                <path
                                    className={styles.cls1}
                                    d="M47.9,49.19c-1.44,0-2.6-1.51-2.6-3.37c0-0.21,0.01-0.42,0.04-0.62c0.04-0.29,0.31-0.49,0.6-0.45
						c0.29,0.04,0.49,0.31,0.45,0.6c-0.02,0.15-0.03,0.31-0.03,0.47c0,1.25,0.71,2.31,1.54,2.31c0.84,0,1.54-1.06,1.54-2.31
						c0-0.16-0.01-0.32-0.03-0.47c-0.04-0.29,0.16-0.56,0.45-0.6c0.29-0.04,0.56,0.16,0.6,0.45c0.03,0.2,0.04,0.41,0.04,0.62
						C50.51,47.68,49.34,49.19,47.9,49.19z"
                                />
                                <path
                                    className={styles.cls1}
                                    d="M47.9,49.79c-1.77,0-3.21-1.78-3.21-3.97c0-0.24,0.02-0.47,0.05-0.71c0.04-0.3,0.2-0.56,0.44-0.75
						c0.24-0.18,0.54-0.26,0.84-0.21c0.61,0.09,1.04,0.66,0.96,1.28c-0.02,0.13-0.03,0.26-0.03,0.38c0,0.96,0.51,1.71,0.94,1.71
						c0.44,0,0.94-0.75,0.94-1.71c0-0.13-0.01-0.26-0.03-0.38c-0.09-0.62,0.34-1.19,0.96-1.28c0.31-0.04,0.6,0.03,0.84,0.22
						c0.24,0.18,0.4,0.45,0.44,0.74c0.03,0.23,0.05,0.47,0.05,0.7C51.11,48.01,49.67,49.79,47.9,49.79z"
                                />
                            </g>
                        </g>
                        <g>
                            <g>
                                <path
                                    className={styles.cls1}
                                    d="M49.3,37.95c-0.39,0-0.76-0.08-1.1-0.24c-0.43-0.2-0.7-0.48-0.91-0.71c-0.22-0.23-0.34-0.35-0.53-0.39
						c-0.46-0.11-1.13,0.29-1.89,1.11c-0.2,0.22-0.54,0.23-0.75,0.03c-0.22-0.2-0.23-0.54-0.03-0.75c1.07-1.16,2.02-1.63,2.91-1.42
						c0.52,0.12,0.81,0.42,1.07,0.7c0.18,0.19,0.34,0.36,0.59,0.47c0.43,0.2,1.11,0.32,2.56-0.51c0.26-0.15,0.58-0.06,0.72,0.2
						c0.15,0.25,0.06,0.58-0.2,0.73C50.8,37.69,50,37.95,49.3,37.95z"
                                />
                                <path
                                    className={styles.cls1}
                                    d="M49.3,38.55c-0.47,0-0.93-0.1-1.36-0.3c-0.54-0.25-0.86-0.59-1.1-0.84c-0.07-0.07-0.19-0.2-0.23-0.22
						c-0.08-0.04-0.55,0.1-1.32,0.93c-0.42,0.46-1.14,0.48-1.6,0.06c-0.46-0.43-0.49-1.14-0.06-1.6c1.23-1.33,2.37-1.85,3.48-1.6
						c0.69,0.16,1.08,0.57,1.36,0.86c0.17,0.18,0.27,0.28,0.41,0.35c0.17,0.08,0.64,0.3,2.01-0.49c0.55-0.3,1.24-0.12,1.54,0.42
						c0.31,0.54,0.12,1.23-0.42,1.54C51,38.27,50.11,38.55,49.3,38.55z M44.51,37.41C44.51,37.41,44.51,37.41,44.51,37.41l0.34,0.32
						L44.51,37.41z"
                                />
                            </g>
                        </g>
                    </g>
                    <g>
                        <g>
                            <g>
                                <g>
                                    <g>
                                        <path
                                            className={styles.cls1}
                                            d="M39.59,21.95H28.76c-0.29,0-0.53-0.24-0.53-0.53c0-0.29,0.24-0.53,0.53-0.53h10.83
								c0.29,0,0.53,0.24,0.53,0.53C40.12,21.72,39.88,21.95,39.59,21.95z"
                                        />
                                        <path
                                            className={styles.cls1}
                                            d="M39.59,22.55H28.76c-0.62,0-1.13-0.51-1.13-1.13c0-0.62,0.51-1.13,1.13-1.13h10.83
								c0.62,0,1.13,0.51,1.13,1.13C40.72,22.05,40.21,22.55,39.59,22.55z"
                                        />
                                    </g>
                                </g>
                                <g>
                                    <g>
                                        <path
                                            className={styles.cls1}
                                            d="M35.15,25.18h-6.39c-0.29,0-0.53-0.24-0.53-0.53c0-0.29,0.24-0.53,0.53-0.53h6.39
								c0.29,0,0.53,0.24,0.53,0.53C35.68,24.94,35.44,25.18,35.15,25.18z"
                                        />
                                        <path
                                            className={styles.cls1}
                                            d="M35.15,25.78h-6.39c-0.62,0-1.13-0.51-1.13-1.13c0-0.62,0.51-1.13,1.13-1.13h6.39
								c0.62,0,1.13,0.51,1.13,1.13C36.28,25.27,35.77,25.78,35.15,25.78z"
                                        />
                                    </g>
                                </g>
                            </g>
                            <g>
                                <g>
                                    <path
                                        className={styles.cls1}
                                        d="M27.9,32.97c-0.07,0-0.14-0.01-0.2-0.04c-0.2-0.08-0.33-0.28-0.33-0.49v-3.81
							c-1.93-1.45-3.04-3.48-3.04-5.6c0-4.27,4.42-7.74,9.84-7.74c5.43,0,9.84,3.47,9.84,7.74s-4.42,7.74-9.84,7.74
							c-1.16,0-2.3-0.16-3.39-0.47l-2.51,2.51C28.17,32.92,28.04,32.97,27.9,32.97z M34.17,16.36c-4.84,0-8.78,3-8.78,6.68
							c0,1.85,1.03,3.63,2.81,4.89c0.14,0.1,0.22,0.26,0.22,0.43l0,2.79l1.83-1.83c0.14-0.14,0.35-0.19,0.54-0.13
							c1.07,0.34,2.21,0.52,3.38,0.52c4.84,0,8.78-3,8.78-6.68S39.01,16.36,34.17,16.36z"
                                    />
                                    <path
                                        className={styles.cls1}
                                        d="M27.9,33.57c-0.15,0-0.3-0.03-0.43-0.08c-0.43-0.18-0.7-0.59-0.7-1.05v-3.51
							c-1.93-1.55-3.04-3.68-3.04-5.89c0-4.6,4.68-8.34,10.44-8.34s10.44,3.74,10.44,8.34s-4.68,8.34-10.44,8.34
							c-1.1,0-2.18-0.13-3.21-0.4l-2.26,2.26C28.49,33.45,28.2,33.57,27.9,33.57z M34.17,16.96c-4.51,0-8.18,2.73-8.18,6.08
							c0,1.65,0.93,3.25,2.56,4.4c0.3,0.21,0.48,0.56,0.48,0.92v1.34l0.8-0.8c0.3-0.3,0.74-0.41,1.14-0.28
							c1.02,0.32,2.09,0.49,3.2,0.49c4.51,0,8.18-2.73,8.18-6.08S38.68,16.96,34.17,16.96z"
                                    />
                                </g>
                            </g>
                        </g>
                        <g>
                            <g>
                                <g>
                                    <path
                                        className={styles.cls1}
                                        d="M42.95,35.95c-0.14,0-0.27-0.05-0.38-0.16l-2-2c-0.88,0.25-1.79,0.37-2.73,0.37
							c-2.67,0-5.17-1.04-6.69-2.77c-0.19-0.22-0.17-0.56,0.05-0.75c0.22-0.19,0.56-0.17,0.75,0.05c1.31,1.51,3.51,2.41,5.88,2.41
							c0.94,0,1.86-0.14,2.72-0.41c0.19-0.06,0.4-0.01,0.54,0.13l1.32,1.32V32.1c0-0.17,0.08-0.33,0.22-0.43
							c1.43-1.01,2.25-2.43,2.25-3.9c0-0.98-0.36-1.94-1.03-2.78c-0.18-0.23-0.15-0.56,0.08-0.75c0.23-0.19,0.56-0.15,0.75,0.08
							c0.83,1.03,1.27,2.22,1.27,3.45c0,1.74-0.9,3.4-2.47,4.61l0,3.05c0,0.21-0.13,0.41-0.33,0.49
							C43.09,35.93,43.02,35.95,42.95,35.95z"
                                    />
                                    <path
                                        className={styles.cls1}
                                        d="M42.95,36.55c-0.3,0-0.59-0.12-0.8-0.33l-1.76-1.76c-0.82,0.2-1.68,0.3-2.55,0.3
							c-2.84,0-5.51-1.11-7.14-2.98c-0.41-0.47-0.36-1.18,0.11-1.59c0.23-0.2,0.51-0.29,0.82-0.28c0.3,0.02,0.58,0.16,0.78,0.39
							c1.2,1.38,3.23,2.2,5.43,2.2c0.88,0,1.73-0.13,2.54-0.39c0.4-0.13,0.84-0.02,1.14,0.28l0.3,0.3V32.1
							c0-0.37,0.18-0.71,0.48-0.92c1.27-0.89,1.99-2.14,1.99-3.41c0-0.84-0.31-1.67-0.9-2.4c-0.39-0.48-0.32-1.2,0.17-1.59
							c0.23-0.19,0.53-0.28,0.83-0.25c0.3,0.03,0.57,0.18,0.76,0.41c0.92,1.14,1.4,2.46,1.4,3.82c0,1.83-0.9,3.6-2.47,4.9v2.76
							c0,0.46-0.27,0.87-0.7,1.04C43.24,36.52,43.09,36.55,42.95,36.55z M44.21,24.69l-0.36,0.29L44.21,24.69L44.21,24.69z"
                                    />
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default GetStartedSupport;
